import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_CHILDDEVICE_DETAILS } from './url-constants';

type DeleteStarfishChildDeviceEndpointSpecification = ApiEndpointSpecification;
export const DeleteStarfishChildDeviceEndpointSpecification: DeleteStarfishChildDeviceEndpointSpecification = {
    url: STARFISH_CHILDDEVICE_DETAILS,
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'DeleteStarfishChildDeviceRequestParams',
    requestBodySchemaName: 'DeleteStarfishChildDeviceRequestBody',
    okResponseSchemaName: 'DeleteStarfishChildDeviceOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3.0
};

export const invokeDeleteStarfishChildDevice = Helpers.makeApiRequestFn
<
    Types.DeleteStarfishChildDeviceRequestParams,
    Types.DeleteStarfishChildDeviceRequestBody,
    Types.DeleteStarfishChildDeviceOkResponse
>
(DeleteStarfishChildDeviceEndpointSpecification);
